import sanitizeHtml from 'sanitize-html';

type BlogSanitizeProfile = 'preview' | 'article';
type HtmlAttributes = Record<string, string>;

const previewConfig: sanitizeHtml.IOptions = {
  allowedTags: ['p', 'br', 'strong', 'em', 'b', 'i', 'span', 'a'],
  allowedAttributes: {
    a: ['href', 'title', 'target', 'rel'],
    span: ['class'],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  allowProtocolRelative: false,
  transformTags: {
    a: (tagName: string, attribs: HtmlAttributes) => {
      const nextAttribs = { ...attribs };

      if (nextAttribs.target === '_blank') {
        nextAttribs.rel = 'noopener noreferrer';
      }

      return { tagName, attribs: nextAttribs };
    },
  },
};

const articleConfig: sanitizeHtml.IOptions = {
  allowedTags: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'br',
    'hr',
    'blockquote',
    'ul',
    'ol',
    'li',
    'strong',
    'em',
    'b',
    'i',
    'u',
    's',
    'pre',
    'code',
    'figure',
    'figcaption',
    'img',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'caption',
    'colgroup',
    'col',
    'span',
    'a',
    'iframe',
  ],
  allowedAttributes: {
    '*': ['class'],
    a: ['href', 'name', 'target', 'rel', 'title'],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
    table: ['width'],
    th: ['colspan', 'rowspan', 'scope', 'headers', 'width', 'align', 'valign'],
    td: ['colspan', 'rowspan', 'headers', 'width', 'align', 'valign'],
    col: ['span', 'width'],
    colgroup: ['span'],
    iframe: [
      'src',
      'title',
      'width',
      'height',
      'allow',
      'allowfullscreen',
      'frameborder',
    ],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  allowedSchemesByTag: {
    img: ['http', 'https'],
  },
  allowedIframeHostnames: [
    'www.youtube.com',
    'youtube.com',
    'player.vimeo.com',
  ],
  allowProtocolRelative: false,
  transformTags: {
    a: (tagName: string, attribs: HtmlAttributes) => {
      const nextAttribs = { ...attribs };

      if (nextAttribs.target === '_blank') {
        nextAttribs.rel = 'noopener noreferrer';
      }

      return { tagName, attribs: nextAttribs };
    },
  },
};

export const sanitizeBlogHtml = (
  input: string | undefined | null,
  profile: BlogSanitizeProfile
) => {
  if (!input) {
    return '';
  }

  const config = profile === 'preview' ? previewConfig : articleConfig;
  return sanitizeHtml(input, config);
};
